"use client";

import React from "react";
import { Compass, Cpu, Printer, Settings, Wrench, ArrowRight } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "ADA Accessibility",
  icon: Compass,
  description: "Our ADA-compliant units feature flat-floor entry and spacious interiors, ensuring dignified access for every guest at your event or site."
}, {
  title: "Fleet Intelligence",
  icon: Cpu,
  description: "We utilize real-time GPS tracking and tank sensors to monitor our fleet, guaranteeing timely servicing and transparent logistics for enterprise clients."
}, {
  title: "Custom Branding",
  icon: Printer,
  description: "From large-format wraps to high-visibility site signage, we offer in-house production to ensure your equipment matches your brand's professional standards."
}, {
  title: "Climate Control",
  icon: Settings,
  description: "Our luxury restroom and shower trailers are equipped with high-efficiency HVAC systems, media setups, and premium fixtures for maximum comfort."
}, {
  title: "Expert Deployment",
  icon: Wrench,
  description: "Our professional operators handle the final site placement with precision, ensuring every unit is securely positioned and ready for immediate service."
}];
export default function The4ElevenMethodology() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section data-section-id="224041" id="premium-asset-showcase" className="bg-background text-foreground">
      <div className="bg-muted/30 py-24 lg:py-32 overflow-hidden">
        <div className="container mx-auto px-4 md:px-6">
          
          <div className="max-w-3xl mx-auto text-center mb-16 md:mb-24">
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 tracking-tight">
              Premium Asset Showcase
            </h2>
            <p className="text-lg text-muted-foreground font-default">
              From high-capacity construction units to luxury event trailers, our turnkey approach ensures your sanitation needs are met with industrial precision and cutting-edge technology.
            </p>
          </div>

          <div className="relative w-full overflow-x-auto pb-12 snap-x snap-mandatory hide-scrollbar" ref={ref}>
            <div className="min-w-[1200px] lg:min-w-full relative px-4 lg:px-0">
              
              {}
              <div className="absolute top-8 left-0 w-full h-1 bg-border rounded-full" />
              
              {}
              <div className="absolute top-8 left-0 h-1 bg-primary rounded-full transition-all duration-1500 ease-out" style={{
              width: isVisible ? '100%' : '0%'
            }} />

              <div className="flex justify-between items-start relative z-10">
                {steps.map((step, i) => <div key={i} data-index={i} className="flex flex-col items-center w-64 snap-center shrink-0">
                    <div className="w-16 h-16 rounded-full bg-background border-4 border-primary flex items-center justify-center text-primary shadow-lg shadow-primary/20 mb-8 relative z-10 transition-transform duration-500 hover:scale-110">
                      <step.icon className="w-8 h-8" />
                    </div>
                    
                    <Card className="w-full bg-card/90 backdrop-blur-sm border-border/50 shadow-md hover:shadow-xl transition-shadow duration-300">
                      <CardHeader className="pb-3 text-center">
                        <div className="text-sm font-mono text-primary font-semibold mb-1">Step 0{i + 1}</div>
                        <CardTitle className="font-default text-xl">{step.title}</CardTitle>
                      </CardHeader>
                      <CardContent>
                        <CardDescription className="text-center text-sm leading-relaxed font-default">
                          {step.description}
                        </CardDescription>
                      </CardContent>
                    </Card>
                  </div>)}
              </div>
            </div>
          </div>

          <div className="mt-16 text-center">
            <Button asChild size="lg" className="rounded-full px-8 bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg shadow-primary/20">
              <Link to="#">
                View Full Inventory
                <ArrowRight className="ml-2 w-4 h-4" />
              </Link>
            </Button>
          </div>

        </div>
      </div>
    </section>;
}